<template>
  <d2-container>
    <template slot="header">
      <el-form :inline="true" size="small" @submit.native.prevent>
        <el-form-item>
          <el-input
            v-model="listQuery.id"
            clearable
            placeholder="密语编号"
            style="width: 170px"
            @keyup.enter.native="search"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="listQuery.senderPhone"
            clearable
            placeholder="发送方手机号"
            style="width: 170px"
            @keyup.enter.native="search"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="listQuery.receiverPhone"
            clearable
            placeholder="接收方手机号"
            style="width: 170px"
            @keyup.enter.native="search"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="listQuery.keyword"
            clearable
            placeholder="内容、署名或接收人"
            style="width: 190px"
            @keyup.enter.native="search"
          />
        </el-form-item>
        <el-form-item>
          <el-select v-model="listQuery.status" clearable placeholder="阅读状态" style="width: 120px">
            <el-option label="未读" :value="0" />
            <el-option label="已读" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="创建开始时间"
            end-placeholder="创建结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 350px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </template>

    <el-row :gutter="12" class="summary-row">
      <el-col v-for="item in summaryCards" :key="item.label" :xs="12" :sm="8" :md="4">
        <el-card shadow="never" class="summary-card">
          <div class="summary-label">{{ item.label }}</div>
          <div class="summary-value">{{ item.value }}</div>
        </el-card>
      </el-col>
    </el-row>

    <el-card shadow="never" class="trend-card">
      <div slot="header" class="trend-header">
        <span>近 7 天新增趋势</span>
        <span class="trend-tip">统计数据与当前筛选条件一致</span>
      </div>
      <el-table :data="stats.trend || []" size="mini" border stripe>
        <el-table-column prop="date" label="日期" min-width="160" />
        <el-table-column prop="count" label="新增密语数" min-width="140" />
      </el-table>
    </el-card>

    <el-table
      v-loading="listLoading"
      :data="records"
      size="small"
      stripe
      border
      highlight-current-row
      style="margin-top: 16px"
    >
      <el-table-column prop="id" label="编号" width="170" align="center" />
      <el-table-column label="发送方" min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.senderNickname || scope.row.formName || '-' }}</div>
          <div class="sub-text">{{ scope.row.senderPhone || ('账户 ID：' + scope.row.accountId) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="接收方" min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.receiverNickname || scope.row.toName || '-' }}</div>
          <div class="sub-text">{{ scope.row.receiverAccountPhone || scope.row.receiverPhone || ('账户 ID：' + (scope.row.receiverId || '-')) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="密语内容" min-width="250">
        <template slot-scope="scope">
          <div class="content-preview">{{ scope.row.textContent || '-' }}</div>
        </template>
      </el-table-column>
      <el-table-column label="媒体" width="130" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.hasImage" size="mini" type="success">图片</el-tag>
          <el-tag v-if="scope.row.hasVideo" size="mini" type="warning" class="media-tag">视频</el-tag>
          <span v-if="!scope.row.hasImage && !scope.row.hasVideo">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="themeName" label="主题" width="130" align="center">
        <template slot-scope="scope">{{ scope.row.themeName || '-' }}</template>
      </el-table-column>
      <el-table-column label="阅读状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 0" size="mini" type="warning">未读</el-tag>
          <el-tag v-else size="mini" type="success">已读</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="170" align="center" />
      <el-table-column label="操作" width="90" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="openDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <template slot="footer">
      <el-pagination
        :current-page.sync="listQuery.currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </template>

    <el-dialog title="密语详情" :visible.sync="detailVisible" width="680px">
      <el-descriptions v-if="selectedRecord" :column="2" border size="small">
        <el-descriptions-item label="密语编号">{{ selectedRecord.id }}</el-descriptions-item>
        <el-descriptions-item label="阅读状态">{{ selectedRecord.status === 0 ? '未读' : '已读' }}</el-descriptions-item>
        <el-descriptions-item label="发送方">{{ selectedRecord.senderNickname || selectedRecord.formName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="发送方手机号">{{ selectedRecord.senderPhone || '-' }}</el-descriptions-item>
        <el-descriptions-item label="接收方">{{ selectedRecord.receiverNickname || selectedRecord.toName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="接收方手机号">{{ selectedRecord.receiverAccountPhone || selectedRecord.receiverPhone || '-' }}</el-descriptions-item>
        <el-descriptions-item label="主题">{{ selectedRecord.themeName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ selectedRecord.createTime }}</el-descriptions-item>
        <el-descriptions-item label="文字内容" :span="2">
          <div class="detail-content">{{ selectedRecord.textContent || '-' }}</div>
        </el-descriptions-item>
        <el-descriptions-item v-if="mediaList(selectedRecord.imgContent).length" label="图片内容" :span="2">
          <el-image
            v-for="url in mediaList(selectedRecord.imgContent)"
            :key="url"
            :src="url"
            :preview-src-list="mediaList(selectedRecord.imgContent)"
            fit="cover"
            class="media-image"
          />
        </el-descriptions-item>
        <el-descriptions-item v-if="mediaList(selectedRecord.videoContent).length" label="视频内容" :span="2">
          <video
            v-for="url in mediaList(selectedRecord.videoContent)"
            :key="url"
            :src="url"
            controls
            class="media-video"
          />
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </d2-container>
</template>

<script>
import {
  getLoveMessageRecordList,
  getLoveMessageRecordStats
} from '@/api/demo/loveMessageRecord'

const emptyQuery = () => ({
  id: '',
  senderPhone: '',
  receiverPhone: '',
  keyword: '',
  status: null,
  createTimeStart: '',
  createTimeEnd: '',
  currentPage: 1,
  pageSize: 20
})

export default {
  name: 'loveMessageRecordManager',
  data () {
    return {
      listQuery: emptyQuery(),
      dateRange: [],
      records: [],
      total: 0,
      listLoading: false,
      stats: {
        totalCount: 0,
        unreadCount: 0,
        readCount: 0,
        senderCount: 0,
        receiverCount: 0,
        trend: []
      },
      detailVisible: false,
      selectedRecord: null
    }
  },
  computed: {
    summaryCards () {
      return [
        { label: '密语总数', value: this.stats.totalCount || 0 },
        { label: '未读数', value: this.stats.unreadCount || 0 },
        { label: '已读数', value: this.stats.readCount || 0 },
        { label: '发送人数', value: this.stats.senderCount || 0 },
        { label: '接收人数', value: this.stats.receiverCount || 0 }
      ]
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    buildQuery () {
      return {
        ...this.listQuery,
        createTimeStart: this.dateRange && this.dateRange.length ? this.dateRange[0] : '',
        createTimeEnd: this.dateRange && this.dateRange.length ? this.dateRange[1] : ''
      }
    },
    loadData () {
      const query = this.buildQuery()
      this.listLoading = true
      Promise.all([
        getLoveMessageRecordList(query),
        getLoveMessageRecordStats(query)
      ]).then(([listResult, statsResult]) => {
        this.records = listResult.records || []
        this.total = Number(listResult.total || 0)
        this.stats = {
          ...this.stats,
          ...statsResult
        }
      }).finally(() => {
        this.listLoading = false
      })
    },
    search () {
      this.listQuery.currentPage = 1
      this.loadData()
    },
    reset () {
      this.listQuery = emptyQuery()
      this.dateRange = []
      this.loadData()
    },
    handleSizeChange (size) {
      this.listQuery.pageSize = size
      this.listQuery.currentPage = 1
      this.loadData()
    },
    handleCurrentChange (page) {
      this.listQuery.currentPage = page
      this.loadData()
    },
    openDetail (record) {
      this.selectedRecord = record
      this.detailVisible = true
    },
    mediaList (value) {
      return value
        ? value.split(',').map(item => item.trim()).filter(Boolean)
        : []
    }
  }
}
</script>

<style scoped>
.summary-row {
  margin-bottom: 12px;
}

.summary-card {
  text-align: center;
}

.summary-label {
  color: #909399;
  font-size: 13px;
}

.summary-value {
  margin-top: 8px;
  color: #303133;
  font-size: 24px;
  font-weight: 600;
}

.trend-card {
  margin-bottom: 4px;
}

.trend-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.trend-tip,
.sub-text {
  color: #909399;
  font-size: 12px;
}

.content-preview {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.media-tag {
  margin-left: 4px;
}

.detail-content {
  white-space: pre-wrap;
  word-break: break-word;
}

.media-image {
  width: 100px;
  height: 100px;
  margin: 0 8px 8px 0;
  cursor: pointer;
}

.media-video {
  width: 260px;
  max-width: 100%;
  margin: 0 8px 8px 0;
}
</style>
